import { Box, Button, Skeleton, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import { DraggableList } from 'src/features/sites/components/draggable-tag-list';
import { TagType } from 'src/features/sites/types/types';
import { RowType } from '../../../ModalEditLiveDataWidget/types';
import { TitleDescription } from '../TitleDescription';
import { StyledScrollBox } from './style';
import { TagResponse } from 'src/types/tags/tags';
import { PlusFillIcon } from 'src/assets/icons/PlusFillIcon';

type Props = {
  gatewayInputs: TagResponse[];
  addRow: () => void;
  rows: RowType[];
  onDragEnd: (result: DropResult) => void;
  handleSetRow: (
    rowId: string,
    tagId: string,
    gatewayId: string,
    parentType: string,
    tag: TagType | null
  ) => void;
  removeRow: (id: string) => void;
  setMobileListWidth: (value: string) => void;
  selectedTags: any;
};

export const LiveDataTagsSection = ({
  gatewayInputs,
  addRow,
  rows,
  onDragEnd,
  handleSetRow,
  removeRow,
  setMobileListWidth,
  selectedTags,
}: Props) => {
  const isDataTagsReady = true; //change this
  const theme = useTheme();

  const dropdownData = useMemo(
    () => ({ value: gatewayInputs?.filter((item: any) => !item.hidden), loaded: isDataTagsReady }),
    [gatewayInputs, isDataTagsReady]
  );

  // useEffect(() => {
  //   if (formttedTags) {
  //     setRows({
  //       value: formttedTags?.map((tag: any, index: any) => ({
  //         id: `${index + 1}`,
  //         position: index + 1,
  //         tagId: tag.id,
  //         gatewayId: tag.gatewayId || '',
  //         tag: tag,
  //       })),
  //       loaded: true,
  //     });
  //   }
  // }, [formttedTags]);

  const handleMobileListWidth = (value: string) => {
    setMobileListWidth(value);
  };

  const isAddTagDisabled = rows.length >= 4;

  return (
    <Box>
      <TitleDescription>Live data</TitleDescription>
      <StyledScrollBox>
        <Box
          sx={{
            minWidth: 'min-content',
            padding: '0 15px',
          }}
        >
          {isDataTagsReady ? (
            <DraggableList
              items={rows}
              selectedTags={selectedTags}
              onDragEnd={onDragEnd}
              onRemoveRow={removeRow}
              dropdownData={dropdownData}
              handleSetRow={handleSetRow}
              handleMobileListWidth={handleMobileListWidth}
              paddingLeft="0px"
              isLiftStation
            />
          ) : (
            <>
              {Array.from({ length: 4 }, (_, k) => (
                <Skeleton
                  animation="wave"
                  variant="rounded"
                  height={'40px'}
                  width={'100%'}
                  sx={{ bgcolor: theme.palette.grey[300], mt: '12px' }}
                  key={k}
                />
              ))}
            </>
          )}
        </Box>
      </StyledScrollBox>
      <Button
        disabled={isAddTagDisabled}
        data-sm="add-tag-live-data"
        startIcon={<PlusFillIcon width={22} height={22} />}
        onClick={addRow}
      >
        Add tag
      </Button>
    </Box>
  );
};
